import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import {
  columnDescription,
  columnMultiSelect,
  columnName,
  columnSize,
  columnTransferable,
  columnType,
} from '@/constants/fields';
import TableWrapper from '@/components/table/TableWrapper';
import { ATTACHMENT_TRANSFER } from '@/datasets/attachments/constants';
import NoAttachmentsRow from '@/datasets/attachments/components/NoAttachmentsRow';
import { states } from '@/constants/lifecycle';
import RequestAttachmentsTableHeader from './RequestAttachmentsTableHeader';
import RequestAttachmentRows from './RequestAttachmentRows';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const buildColumns = (attachments, isRoot) => {
  const columns = [
    isRoot ? columnMultiSelect : null,
    columnName,
    columnDescription,
    columnType,
    columnSize,
  ].filter(Boolean);

  const hasTransferable = attachments.some(({ metadata }) => [
    ATTACHMENT_TRANSFER.required.name,
    ATTACHMENT_TRANSFER.recommended.name,
  ].includes(metadata.transferable));

  if (hasTransferable && isRoot) {
    columns.push(columnTransferable);
  }

  return columns;
};

const RequestAttachmentsTable = ({ category, className, code }) => {
  const { attachments, readStatus, isRoot } = Selectors.useRequestAttachmentsTable({ category, code });
  const onSelect = Events.useToggleRequestAttachmentSelected(category, { code });
  const onFolderClick = Events.useRequestAttachmentFolderPush(category, { code });
  const columns = buildColumns(attachments, isRoot);

  return (
    <div className={clsx('ReactTable aridhia-select-attachments', className)}>
      <TableWrapper sticky celled className="aridhia-select-attachments-table" columns={columns}>
        <RequestAttachmentsTableHeader category={category} code={code} attachments={attachments} columns={columns} />
        <Table.Body>
          {attachments.length > 0 && (
            <RequestAttachmentRows
              attachments={attachments}
              columns={columns}
              isRoot={isRoot}
              onCheckBoxClick={isRoot ? (attachmentId) => onSelect({ attachmentId }) : undefined}
              onFolderClick={onFolderClick}
            />
          )}
          {attachments.length === 0 && readStatus === states.SUCCESS && (
            <NoAttachmentsRow colSpan={columns.length} />
          )}
          {attachments.length === 0 && (<NoAttachmentsRow colSpan={columns.length} />)}
        </Table.Body>
      </TableWrapper>
    </div>
  );
};

export default RequestAttachmentsTable;
